import { DiffSyncSchema } from "@megaron/diff-sync-contracts";
import { Serializers } from "@megaron/serializers";

import { bcItemSerializer, shopifyProductSerialzier, shopifyProductVariantSerializer } from "./externalItems";
import { itemSerializer } from "./items";
import { priceListSerializer, priceSheetRowSerializer, shopifyPriceSerializer } from "./priceLists";

export const catalogDiffSyncSchema = DiffSyncSchema({
  bcItem: bcItemSerializer,
  sheetsItem: itemSerializer.partial(),
  sheetsPriceList: priceListSerializer,
  sheetsPrice: priceSheetRowSerializer.partial(),
  shopifyProduct: shopifyProductSerialzier.partial(),
  shopifyVariant: shopifyProductVariantSerializer.partial(),
  shopifyPrice: shopifyPriceSerializer.partial(),
});

export type CatalogDiffSyncChannel = keyof typeof catalogDiffSyncSchema & string;
export const catalogDiffSyncChannels = Object.keys(catalogDiffSyncSchema) as CatalogDiffSyncChannel[];
export const catalogDiffSyncChannelSerializer = Serializers.stringOneOf<CatalogDiffSyncChannel>(
  ...catalogDiffSyncChannels,
);
